import * as React from 'react';

const TeepeeSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="teepee_svg__eds-icon--teepee_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 22L12.9 6l1.8-1.8-.7-.7L12.5 5V2h-1v3L10 3.5l-.7.7L11.1 6 2 22h20zm-9-1h-2v-4h2v4zM11.5 7.4V10h1V7.4L20.3 21H14v-4h1v-1H9v1h1v4H3.7l7.8-13.6z"
        />
    </svg>
);

TeepeeSvg.displayName = 'TeepeeSvg';
export default TeepeeSvg;
